import { Operator } from '@img-arena/consoles-api-streaming'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export type OperatorSortAttribute =
  | 'id'
  | 'name'
  | 'mainContactName'
  | 'mainContactEmail'
  | 'mainContactTel'
  | 'createdAt'
export type OperatorFilterParamName = 'filter'

const fetchApi = async (
  args: FetchApiArgs<object, OperatorSortAttribute, OperatorFilterParamName>
): Promise<FetchApiResponse<Operator>> => {
  const { page, pageSize, sort, filters, signal } = args

  const queryFromFilters = filters?.filter?.[0]?.value?.toString() || undefined

  const {
    data: { content, ...restResponse }
  } = await streamingRestApi.endpoints.operators.getAll(
    {
      page,
      pageSize,
      sortKey: sort?.attribute,
      sortDirection: sort?.order,
      query: queryFromFilters
    },
    signal
  )

  return {
    content,
    totalElements: restResponse.totalElements,
    number: restResponse.number,
    size: restResponse.size
  }
}

export const useOperatorsStoreDGE = createBaseTableStore({
  storeName: 'DGE Operators',
  fetchApi,
  features: {
    pagination: true,
    sorting: true,
    filtering: true
  }
})
